import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      let sessionId = null;
      
      // Check hash first (Emergent default)
      const hashMatch = location.hash.match(/session_id=([^&]+)/);
      if (hashMatch) {
        sessionId = hashMatch[1];
      } else {
        // Check query params
        const searchParams = new URLSearchParams(location.search);
        sessionId = searchParams.get("session_id");
      }
      
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }


      try {
        // Clear old cookie first
        document.cookie = "session_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        
        const response = await api.post("/auth/session", { session_id: sessionId });
        
        // Set the new session cookie explicitly
        if (response.data.session_token) {
          document.cookie = `session_token=${response.data.session_token}; path=/; max-age=${30 * 24 * 60 * 60}; SameSite=None; Secure`;
          localStorage.setItem('session_token', response.data.session_token);
        }
        
        setUser(response.data.user);
        toast.success(`Namaste ${response.data.user.name}! Welcome to MeaLVeda AI`);
        
        // Use window.location for hard redirect to ensure cookies are sent
        window.location.href = "/dashboard";
      } catch (error) {
        console.error("AuthCallback: Auth error", error);
        toast.error("Authentication failed. Please try again.");
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [location.hash, location.search, navigate, setUser]);

  return (
    <div className="mobile-container flex items-center justify-center min-h-screen bg-stone-900">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-amber-500 animate-spin mx-auto mb-4" />
        <p className="text-stone-400 font-medium">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
